module.exports = __webpack_public_path__ + "img/tail-spin.6b34a8e2.svg";